import Base from "./base";

export default class Paparazzi extends Base {

    makeExternalPayment(newStep) {
        this.props.externalFunc.depositPaparazzi({
            amount: parseInt(this.state.stake)
        }, (data) => {
            this.setState({
                externalUrl: data.Url,
                currentStep: newStep
            })
        });
    }

    makeExternalPaymentWithBonus(newStep, bonusId) {
        this.props.externalFunc.depositPaparazzi({
            amount: parseInt(this.state.stake),
            claimsBonus: true,
            bonusId: bonusId
        }, (data) => {
            this.setState({
                externalUrl: data.Url,
                currentStep: newStep
            })
        });
    }
}
